import React from "react";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";

import messages from "../../assets/i18n";
import "./UploadFiles.scss";
import iconUpload from "../../assets/images/icons/icon-upload.svg";
import iconXML from "../../assets/images/icons/icon-xml.svg";
import iconPDF from "../../assets/images/icons/icon-pdf.svg";
import { Container, Row, Col } from "react-bootstrap";
import { ButtonStandard } from "../../components";

function UploadFiles(props) {
  const { validateAndStoreLocalFile, uploadedFile, accept } = props;
// = 'text/xml'
  const lang = useSelector(state => state.language.name)
  const errorAccept = accept === 'application/pdf' ? 'isFilePDF' : 'isFileXML' ;

  return (
    <Container className="uploadFiles">
      <Row>
        <Col>
          <Dropzone
            onDrop={acceptedFiles => validateAndStoreLocalFile(acceptedFiles) }
            accept={accept}
          >
            {({
              getRootProps,
              getInputProps,
              isDragActive,
              isDragReject
            }) => (
              <section>
                {!uploadedFile && (
                  <div
                    {...getRootProps()}
                    className="upload-container"
                  >
                    <input
                      input="reconcile_file_input"
                      {...getInputProps()}
                      required
                    />
                    {!isDragActive && (
                      <div className="text-center">
                        <img width="167" src={iconUpload} alt={messages[lang].importFile} />
                        <p className="txt-description">
                          { messages[lang].dragAndDroptheDocument }
                        </p>
                        <ButtonStandard
                          id="reconcile_attach_file_button"
                          text={ messages[lang].attachFile }
                          textClass="text-2"
                          className="btn btn-primary btn-rounded btn-standard px-4 btn-upload"
                        />
                      </div>
                    )}
                    {isDragActive && !isDragReject && (
                      <p className="txt-description">
                        { messages[lang].dropHere }
                      </p>
                    )}
                    {isDragReject && (
                      <p className="txt-description">
                        { accept === 'application/pdf' ? messages[lang].mustBePDF : messages[lang].mustBeXML }
                      </p>
                    )}
                  </div>
                )}
                {uploadedFile && (
                  <Row className="file-uploaded">
                    <Col xs={2}>
                      {
                        accept === 'application/pdf' &&
                        <img width="32" src={iconPDF} alt={messages[lang][errorAccept]} />
                      }
                      {
                        accept !== 'application/pdf' &&
                        <img width="32" src={iconXML} alt={messages[lang][errorAccept]} />
                      }
                    </Col>

                    <Col xs={8}>
                      <p className="text-4 text-color-primary">
                        { uploadedFile.name }
                      </p>
                    </Col>
                    
                    <Col xs={2}>
                      {props.downloadFile && (
                        <button
                          className="btn-download"
                          id="reconcile_download_file_button"
                          onClick={ props.downloadFile }
                        >
                          <i className="icon-download" />
                        </button>
                      )}
                      {props.removeFile ? (
                        <button
                          className="btn-remove"
                          id="reconcile_remove_file_button"
                          onClick={ props.removeFile }
                        >
                          <i className="icon-remove" />
                        </button>
                      ) : null}
                    </Col>
                  </Row>
                )}
              </section>
            )}
          </Dropzone>
        </Col>
      </Row>
    </Container>
  );
}

UploadFiles.propTypes = {
  validateAndStoreLocalFile: PropTypes.func,
  uploadedFile: PropTypes.object,
  removeFile: PropTypes.func,
  downloadFile: PropTypes.func,
  accept: PropTypes.oneOf(['txt/xml', 'application/pdf', '.doc,.docx,application/pdf']),
};

const mapStateToProps = state => ({
  lang: state.language
});

export default connect(mapStateToProps)(UploadFiles);
